<template>
  <div>
    <div class="demo__font--20 demo__weight--600 demo__color--black">
      {{ $t("Login for users") }}
    </div>
    <div class="demo__font--16 demo__weight--400 demo__margin-top--8">
      {{ $t("Login for users 2") }}
    </div>
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      class="demo__FormModal demo__align-left demo__margin-top--24"
    >
      <a-form-model-item
        ref="username"
        prop="username"
        :label="$t('Login')"
        v-bind:class="{ 'has-error': loginResult }"
      >
        <a-input
          id="username"
          v-model="form.username"
          data-testid="login"
          class="demo__input"
          @keyup.enter="onSubmit"
          @blur="
            () => {
              $refs.username.onFieldBlur();
            }
          "
        />
      </a-form-model-item>
      <a-form-model-item
        ref="password"
        prop="password"
        :label="$t('Password')"
        class="demo__margin-top--16"
        v-bind:class="{ 'has-error': loginResult }"
      >
        <a-input-password
          v-model="form.password"
          data-testid="password"
          class="demo__input--password"
          @keyup.enter="onSubmit"
          @blur="
            () => {
              $refs.password.onFieldBlur();
            }
          "
        />

        <div
          class="demo__FormModal--result demo__margin-top--16"
          v-show="loginResult"
        >
          {{ loginResult ? loginResult : false }}
        </div>
      </a-form-model-item>
      <a-form-model-item class="demo__margin-top--24">
        <div class="demo__buttons--half">
          <a-button
            :disabled="!form.username || !form.password"
            class="demo__button demo__button--base demo__button--full"
            @click="onSubmit"
          >
            {{ $t("Submit") }}
          </a-button>

          <AuthLockBlock
            class="demo__inline-block"
            modal-status="Reg"
            :ym-params="{
              step: 1,
            }"
          >
            <a-button class="demo__button demo__button--gray demo__width-full">
              {{ $t("Register") }}
            </a-button>
          </AuthLockBlock>
        </div>

        <a-form-model-item class="demo__margin-top--24">
          <div
            class="demo__color--brandPrimary demo__font-14 demo__weight--600"
          >
            <AuthLockBlock modal-status="ResetPassword" class="demo__pointer"
              >{{ $t("Forgot password?") }}
            </AuthLockBlock>
          </div>
        </a-form-model-item>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      a: window.navigator.userAgent,
      loginResult: undefined,
      form: {
        username: undefined,
        password: undefined,
      },
    };
  },
  computed: {
    ...mapGetters([
      "user",
      "api",
      "agent",
      "isMobile",
      "userLinks",
      "currentLang",
    ]),
    rules() {
      return {
        username: [
          {
            required: true,
            message: this.$t("Field required"),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("Field required"),
            trigger: "blur",
          },
        ],
      };
    },
    localhost() {
      return window.location.hostname === "localhost" ? true : false;
    },
  },
  watch: {
    form: {
      handler() {
        this.loginResult = undefined;
      },
      deep: true,
    },
  },
  mounted() {
    this.$accessModule("login", this);
  },
  methods: {
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.authLogin();
        } else {
          this.$debug("Форма авторизации заполнена неверно!", "error");
          return false;
        }
      });
    },
    authLogin() {
      this.api
        .auth({
          data: {
            username: this.form.username,
            password: this.form.password,
          },
        })
        .then((response) => {
          if (response.data.token) {
            this.$store.dispatch("updateToken", response.data.token);
            this.$root.getUserInfo();
            this.$root.$emit("startUserUpdate");

            this.$store.dispatch("updateAuthModalStatus", false);

            this.$debug("Успешная авторизация", "success", response.data);
          } else {
            throw response.data;
          }
        })
        .catch((error) => {
          const error_message = error.message;
          let text;
          switch (error_message) {
            case "Network Error":
              text = this.$t("Auth error network");
              break;

            case "Request failed with status code 400":
              text = this.$t("Auth error 400");
              break;

            default:
              text = this.$t("Auth error unknown");
              break;
          }
          this.$debug("Ошибка авторизации " + text, "error", error_message);
          this.loginResult = text;
        });
    },
  },
};
</script>
